import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

@Injectable({
	providedIn: 'root'
})
export class DeviceService {
	private uuidKey = 'device_uuid';

	constructor() {}

	getDeviceUUID(): string {
		let uuid = localStorage.getItem(this.uuidKey);
		if (!uuid) {
			uuid = uuidv4();
			localStorage.setItem(this.uuidKey, uuid);
		}
		return uuid;
	}

	getSystemInfo(): any {
		return {
			userAgent: navigator.userAgent,
			platform: navigator.platform,
			language: navigator.language,
			screen: {
				width: screen.width,
				height: screen.height,
				colorDepth: screen.colorDepth
			},
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			timezoneOffset: new Date().getTimezoneOffset(),
			hardwareConcurrency: navigator.hardwareConcurrency || 'unknown',
			//deviceMemory: navigator.deviceMemory || 'unknown',
			touchSupport:
        'ontouchstart' in window || navigator.maxTouchPoints > 0,
			vendor: navigator.vendor,
			appVersion: navigator.appVersion
		};
	}

	async getFingerprint(): Promise<string> {
		const fp = await FingerprintJS.load();
		const result = await fp.get();
		return result.visitorId;
	}

	async getFullDeviceId(): Promise<{ uuid: string; fingerprint: string; info: any }> {
    
		const fingerprint = await this.getFingerprint();
		const uuid = fingerprint;
		const info = this.getSystemInfo();
		return { uuid, fingerprint, info };
	}
}
